import React from 'react'
import styled from 'styled-components'

const ImageWrapper = styled.div`
  display: flex;
  flex: 1;
`

const Image = styled.img`
  background-color: var(--black-10);
  max-height: 80vh;
`

interface Props {
  image: string
}

export const ReviewImageModal = ({ image }: Props) => (
  <ImageWrapper>
    <Image src={image} />
  </ImageWrapper>
)
